export default "__VITE_ASSET__47zmwSHQ__"